import React, { useState, useEffect, useCallback } from "react";
import { Link, NavLink } from "react-router-dom";
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import EventNoteRoundedIcon from '@mui/icons-material/EventNoteRounded';
import PushPinRoundedIcon from '@mui/icons-material/PushPinRounded';
import axiosInstance from "../../api/axiosInstance";
import "../navbar/navbar.scss";

const Navbar = () => {

    const [user, setUser] = useState([]);

    const fetchData = useCallback(async () => {
        try {
            const [userRes] = await Promise.all([
                axiosInstance.get('users/account')
            ]);
            setUser(userRes.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div className="navbar">
            <Link to="/">
                <img src="../assets/icon.svg" alt="Logo" />
            </Link>
            <div className="navBar">
                <NavLink className="item" to={"/"}>
                    <HomeRoundedIcon />
                </NavLink>
                <NavLink className="item" to={"/suche"}>
                    <SearchRoundedIcon />
                </NavLink>
                <NavLink className="item" to={"/kalender"}>
                    <EventNoteRoundedIcon />
                </NavLink>
                <NavLink className="item" to={"/orte"}>
                    <PushPinRoundedIcon />
                </NavLink>
                <NavLink className="account" to={"/account"}>
                    <div className="userImage">
                        {user.username
                            ? <img src={"https://api.kolhaupt.it/uploads/" + user.img} alt={"Profilbild " + user.username} />
                            : <img src="/assets/avatar.jpg" alt="User" />
                        }

                    </div>
                </NavLink>
            </div>
        </div>
    )
};

export default Navbar